const generateId = () => Date.now().toString();

export default generateId;
